<script>
  import { onMount } from 'svelte';
  import { page } from '$app/state';
  import { toStore } from 'svelte/store';
  // SvelteKit 3 removes $app/stores. This component is still legacy mode, where
  // $app/state alone is not reactive, so what its `$:` statements read is bridged
  // back into a store with Svelte's toStore (hub ledger 2026-10-23-125).
  const pageUrl = toStore(() => page.url);
  import { captureEvent } from '#lib/utils/posthog.js';
  import { pendingCta } from '#lib/utils/pending-cta.js';

  let visible = false;

  $: pathname = $pageUrl.pathname;
  $: showOnPage = pathname === '/' || pathname.startsWith('/products/') || pathname.startsWith('/b2b');

  onMount(() => {
    const handleScroll = () => {
      const scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
      visible = scrollPercent > 20 && scrollPercent < 95;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  });
</script>

{#if showOnPage}
  <div class="sticky-cta" class:visible aria-hidden={!visible}>
    <a
      href="/products/the-glorb/"
      class="cta-button"
      data-testid="cta-sticky_mobile"
      use:pendingCta={{ onFirstClick: () => captureEvent('cta_click', { location: 'sticky_mobile' }) }}
    >
      Shop GLORB
    </a>
  </div>
{/if}

<style>
  .sticky-cta {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 500;
    display: flex;
    justify-content: center;
    padding: 0.75rem 1rem;
    background: white;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.08);
    transform: translateY(100%);
    transition: transform 0.3s ease;
    pointer-events: none;
  }

  .sticky-cta.visible {
    transform: translateY(0);
    pointer-events: auto;
  }

  /* Off while the burger menu is open (Burger.svelte sets html.menu-open).
     The bar sits at z-index 500 on the page, the menu panel at 1000 but
     inside the header's stacking context (z-index 1), so the bar painted over
     the bottom of the open menu (Simon, 2026-10-01; hub rule R002). Taking the
     bar away leaves the header's stacking order alone. */
  :global(html.menu-open) .sticky-cta {
    display: none;
  }

  .cta-button {
    display: block;
    width: 100%;
    max-width: 400px;
    padding: 0.875rem 1.5rem;
    background: black;
    color: white;
    text-align: center;
    font-size: 0.9rem;
    font-weight: 600;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    text-decoration: none;
    transition: background 0.2s;
  }

  .cta-button:hover {
    background: #333;
  }

  /* Only show on mobile */
  @media (min-width: 860px) {
    .sticky-cta {
      display: none;
    }
  }
</style>
